import { observer } from 'mobx-react-lite';
type ElementObject = {
  [key: string]: string;
};

interface DynamicTableProps {
  elementObject?: ElementObject;
}

const FilmReportDynamicTable: React.FC<DynamicTableProps> = ({
  elementObject,
}) => {
  if (!elementObject) {
    // Handle the case when elementObject is undefined or null
    return null; // or return some default content or an error message
  }

  const obj = elementObject as ElementObject;
  return (
    <table className="table">
      <tbody>
        {Object.entries(obj).map(([key, value]) => (
          <tr key={key}>
            <td className="table-td-key ">
              {key
                ?.replaceAll('_', ' ')
                ?.replace(/^(.)/, (match) => match.toUpperCase())}
            </td>
            <td className="table-td-value">
              :{' '}
              {value
                ?.replaceAll('_', ' ')
                ?.replace(/^(.)/, (match) => match.toUpperCase())}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default observer(FilmReportDynamicTable);
